// extracted by mini-css-extract-plugin
export default {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","promoArea":"dvVvo KbmUc","promoIcon":"_2bhql","promoText":"_2U_WC _2AZKg _1bfQU","promoTCsIcon":"NXG_n","promoTCs":"_3IoLc"};